export const acqModeValues = {
  NO_KPI: 'no-kpi',
  WITH_KPI: 'with-kpi'
}

export const acqModeOptions = [
  {
    label: 'No KPI',
    value: acqModeValues.NO_KPI,
    acqMode: acqModeValues.NO_KPI
  },
  {
    label: 'With KPI',
    value: acqModeValues.WITH_KPI,
    acqMode: acqModeValues.WITH_KPI
  },
];

export const polarizationOptions = [
  {
    label: 'Horizontal',
    value: 'horizontal',
    polarization: 'horizontal'
  },
  {
    label: 'Vertical',
    value: 'vertical',
    polarization: 'vertical'
  }
];

export const scsOptions = [
  {
    label: '3 (120 kHz)',
    value: 120,
    scs: '3 (120 kHz)'
  },
  {
    label: '4 (240 kHz)',
    value: 240,
    scs: '4 (240 kHz)'
  }
];

export const PCI_RANGE = {
  min: 0,
  max: 1007
};

export const SSB_ARFCN_RANGE = {
  'ga2-n257': {
    min: 2054167,
    max: 2104165
  },
  'ga2-n260': {
    min: 2229167,
    max: 2279165
  }
};

export const validateIntegerInRange = (value, range, errorMsg) => {
  if (value === '' || value === undefined) {
    return true;
  }
  const integerRegex = /^-?\d+$/; // Regular expression to accept positive and negative integers
  if (!integerRegex.test(value)) {
    return 'Value must be a valid integer.';
  }
  const intValue = parseInt(value);
  if (Number.isNaN(intValue) || intValue < range.min || intValue > range.max) {
    return errorMsg;
  }
  return true;
};

export const validatePCI = (value) =>
  validateIntegerInRange(value, PCI_RANGE, `PCI must be in the range of ${PCI_RANGE.min} and ${PCI_RANGE.max}`);

export const validateSsbArfcn = (value, productType) =>
  validateIntegerInRange(
    value,
    SSB_ARFCN_RANGE[productType],
    `SSB Arfcn must be in the range of ${SSB_ARFCN_RANGE[productType].min} and ${SSB_ARFCN_RANGE[productType].max} .`
  );
